// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2HDk5","header":"MessagesList_header__ISmLJ","chat":"MessagesList_chat__3ABeB"};